const cache = new Map()

export function buildCacheKey(actionName, ...params) {
    return `${actionName}:${params.join(':')}`
}

export function checkCache(key, ttlMs) {
    const entry = cache.get(key)
    if (!entry) return null
    if (Date.now() - entry.timestamp > ttlMs) {
        cache.delete(key)
        return null
    }
    return entry.value
}

export function setCache(key, value) {
    cache.set(key, { value, timestamp: Date.now() })
}

export function invalidateCache(key) {
    cache.delete(key)
}

export function invalidateCacheByPrefix(prefix) {
    for (const key of cache.keys()) {
        if (key.startsWith(prefix)) {
            cache.delete(key)
        }
    }
}

export function clearAllCaches() {
    cache.clear()
}
